import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface Establishment {
  id: string;
  name: string;
  uai?: string;
}

interface AdminState {
  currentEstablishment: Establishment | null;
  setCurrentEstablishment: (establishment: Establishment | null) => void;
  // Hydration state
  _hasHydrated: boolean;
  setHasHydrated: (state: boolean) => void;
}

export const useAdminStore = create<AdminState>()(
  persist(
    (set) => ({
      currentEstablishment: null,
      setCurrentEstablishment: (establishment) =>
        set({ currentEstablishment: establishment }),
      // Hydration state
      _hasHydrated: false,
      setHasHydrated: (state) => set({ _hasHydrated: state }),
    }),
    {
      name: 'admin-context-storage',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
      // Ne pas persister le flag d'hydratation
      partialize: (state) => ({
        currentEstablishment: state.currentEstablishment,
      }),
    }
  )
);

/**
 * Hook pour attendre l'hydratation du store
 */
export const useAdminStoreHydrated = () =>
  useAdminStore((state) => state._hasHydrated);
